var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy294(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M89.6,4c3.1,0,5.6,2.5,5.6,5.6v80c0,3.1-2.5,5.6-5.6,5.6h-80c-3.1,0-5.6-2.5-5.6-5.6v-80C4,6.5,6.5,4,9.6,4 H89.6 M89.6,0h-80C4.3,0,0,4.3,0,9.6v80c0,5.3,4.3,9.6,9.6,9.6h80c5.3,0,9.6-4.3,9.6-9.6v-80C99.2,4.3,94.9,0,89.6,0L89.6,0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M77.5,44c0,0-8,0-8,0c1.6-4.2,0.2-7.3,0.2-9.1c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 76,
    y1: 38.6,
    x2: 68.4,
    y2: 38.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 22.5,
    y1: 65.4,
    x2: 22.6,
    y2: 61.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 25.8,
    y1: 65.4,
    x2: 25.8,
    y2: 61.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.1,
    y1: 65.4,
    x2: 29.1,
    y2: 61.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 32.4,
    y1: 65.4,
    x2: 32.4,
    y2: 61.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 35.6,
    y1: 65.4,
    x2: 35.7,
    y2: 61.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 38.9,
    y1: 65.4,
    x2: 39,
    y2: 61.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 42.2,
    y1: 65.4,
    x2: 42.2,
    y2: 61.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M82.9,70.8H16.3c-0.7,0-1.3-0.6-1.3-1.3V29.7c0-0.7,0.6-1.3,1.3-1.3h66.6c0.7,0,1.3,0.6,1.3,1.3v39.9 C84.1,70.3,83.6,70.8,82.9,70.8z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 16.3,
    y1: 47,
    x2: 83.7,
    y2: 47
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M68.2,58.8c0.2-0.4,0.4-0.7,0.6-1c0.1-0.2,0.3-0.5,0.5-0.8l0,0l0,0c0.8-1,2-1.7,3.3-1.7 c1.1,0,2.2,0.5,2.9,1.2c0.3,0.3,0.6,0.7,0.8,1.2c0.2,0.4,0.7,0.6,1.2,0.4C78,58,78.2,57.5,78,57l0,0c-0.3-0.6-0.7-1.2-1.2-1.6 l0,0c-1.1-1.1-2.5-1.7-4.2-1.7c-1.9,0-3.6,0.9-4.7,2.3l0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c-0.2,0.3-0.5,0.6-0.7,0.9l0,0 c-0.2,0.3-0.4,0.6-0.6,1c0,0,0,0,0,0c0,0,0,0,0,0c-0.2,0.4-0.4,0.8-0.6,1.1l0,0v0c0,0-0.1,0.3-0.3,0.7c-0.3,0.5-0.6,1.1-0.8,1.4 l0,0c-0.1,0.2-0.3,0.5-0.6,0.8l0,0l0,0c-0.8,1-2,1.7-3.3,1.7c-1.1,0-2.2-0.5-2.9-1.2c-0.8-0.7-1.2-1.8-1.2-2.9 c0-1.1,0.5-2.2,1.2-2.9c0.8-0.7,1.8-1.2,2.9-1.2c1.4,0,2.6,0.6,3.3,1.7l0,0c0,0,0,0,0,0c0.1,0.2,0.2,0.3,0.4,0.5 c0.3,0.4,0.8,0.5,1.2,0.2c0.4-0.3,0.5-0.8,0.2-1.2l0,0c-0.1-0.2-0.3-0.4-0.4-0.6l0,0c-1.1-1.4-2.8-2.3-4.7-2.3 c-1.6,0-3.1,0.7-4.2,1.7c-1.1,1.1-1.7,2.5-1.7,4.1c0,1.6,0.7,3.1,1.7,4.1c1.1,1.1,2.5,1.7,4.2,1.7c1.9,0,3.6-0.9,4.7-2.3l0,0 c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0.2-0.3,0.5-0.6,0.7-0.9l0,0c0.2-0.4,0.5-0.9,0.8-1.4c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1 c0.1-0.2,0.2-0.4,0.3-0.6l0,0l0,0C67.7,59.9,67.9,59.4,68.2,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M77.6,60.9c-0.4-0.2-1,0-1.2,0.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.8,0.7-1.8,1.2-2.9,1.2c-1.4,0-2.6-0.6-3.3-1.7 l0,0c0,0,0-0.1-0.1-0.1c-0.2-0.2-0.4-0.3-0.6-0.3h0c-0.5,0-0.9,0.4-0.9,0.9c0,0,0,0,0,0c0,0.1,0,0.2,0.1,0.3c0,0,0,0.1,0.1,0.1 c0,0,0,0.1,0.1,0.1c1.1,1.4,2.8,2.3,4.7,2.3c1.6,0,3.1-0.7,4.2-1.7c0.5-0.5,0.9-1,1.2-1.6C78.2,61.6,78,61.1,77.6,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M77.7,58.7h-5.6c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h5.6c0.5,0,0.9-0.4,0.9-0.9 C78.6,59.1,78.2,58.7,77.7,58.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.1,
    y1: 70,
    x2: 29.1,
    y2: 28.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M26.7,36.3c1.9,1.9,2.4,9.3,2.4,9.3s-7.4-0.6-9.3-2.4s-1.9-5,0-6.9S24.8,34.4,26.7,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M31.6,36.3c-1.9,1.9-2.4,9.3-2.4,9.3s7.4-0.6,9.3-2.4s1.9-5,0-6.9S33.5,34.4,31.6,36.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.1,
    y1: 45.6,
    x2: 20.6,
    y2: 52.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.1,
    y1: 45.6,
    x2: 37.6,
    y2: 52.1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy294);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-294.f9971cdb431ae5dbde4fd87b8b4db368.svg";
export { ForwardRef as ReactComponent };